export default __webpack_public_path__ + "static/media/dash.4f278cb8.png";